/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Processing_LabelInputs */

const en_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing...`)
};

const fr_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement...`)
};

const de_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung...`)
};

const it_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione in corso...`)
};

const ru_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка...`)
};

const es_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamiento...`)
};

const zh_cn2_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加工...`)
};

const ja_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理...`)
};

const hi_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया जारी है...`)
};

const pt_pt2_embed_captions_processing_label = /** @type {(inputs: Embed_Captions_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento...`)
};

/**
* | output |
* | --- |
* | "Processing..." |
*
* @param {Embed_Captions_Processing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_processing_label = /** @type {((inputs?: Embed_Captions_Processing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Processing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_processing_label(inputs)
	if (locale === "de") return de_embed_captions_processing_label(inputs)
	if (locale === "it") return it_embed_captions_processing_label(inputs)
	if (locale === "ru") return ru_embed_captions_processing_label(inputs)
	if (locale === "es") return es_embed_captions_processing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_processing_label(inputs)
	if (locale === "ja") return ja_embed_captions_processing_label(inputs)
	if (locale === "hi") return hi_embed_captions_processing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_processing_label(inputs)
	return en_embed_captions_processing_label(inputs)
});